(() => {
  const initKizzuPageWrapper = () => {
    const pageSettings = document.querySelector(
      '[data-kizzu-page-settings]'
    );

    const firstSection = document.querySelector(
      '.section-kizzu-image-grid'
    );

    if (!pageSettings || !firstSection) return;

    let wrapper = document.querySelector('.kizzu-page-wrapper');

    if (!wrapper) {
      const sections = [];
      let current = firstSection;

      while (
        current &&
        current.classList.contains('section-kizzu-image-grid')
      ) {
        sections.push(current);
        current = current.nextElementSibling;
      }

      if (!sections.length) return;

      wrapper = document.createElement('div');
      wrapper.className = 'kizzu-page-wrapper';

      firstSection.before(wrapper);

      sections.forEach((section) => {
        wrapper.appendChild(section);
      });
    }

    const background = pageSettings.dataset.kizzuPageBackground;

    if (background) {
      wrapper.style.backgroundImage = `url("${background}")`;
    } else {
      wrapper.style.removeProperty('background-image');
    }
  };
  /*
   * =========================================================
   * KIZZU MOTION
   * =========================================================
   */

  let hasUserInteracted = false;

  const motionObservers = new Map();

  const runMotion = (motion) => {
    if (motion.classList.contains('is-motion-triggered')) return;

    motion.classList.add('is-motion-triggered');

    const observer = motionObservers.get(motion);

    if (observer) {
      observer.unobserve(motion);
      motionObservers.delete(motion);
    }
  };

  const isMotionVisible = (motion) => {
    const rect = motion.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;

    if (rect.height <= 0) return false;

    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, viewportHeight);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);

    return visibleHeight / rect.height >= 0.2;
  };

  const triggerVisibleMotions = () => {
    document.querySelectorAll('[data-kizzu-motion]').forEach((motion) => {
      if (motion.classList.contains('is-motion-triggered')) return;
      if (!isMotionVisible(motion)) return;

      runMotion(motion);
    });
  };

  const enableMotion = () => {
    if (hasUserInteracted) return;

    hasUserInteracted = true;

    requestAnimationFrame(() => {
      triggerVisibleMotions();
    });
  };

  const initKizzuMotion = (scope = document) => {
    scope.querySelectorAll('[data-kizzu-motion]').forEach((motion) => {
      if (motion.dataset.kizzuMotionInitialized === 'true') return;

      motion.dataset.kizzuMotionInitialized = 'true';

      if (!('IntersectionObserver' in window)) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!hasUserInteracted) return;
            if (!entry.isIntersecting) return;
            if (entry.intersectionRatio < 0.2) return;

            runMotion(motion);
          });
        },
        {
          threshold: 0.2
        }
      );

      motionObservers.set(motion, observer);
      observer.observe(motion);
    });
  };

  const handleKeydown = (event) => {
    const scrollKeys = [
      'ArrowDown',
      'ArrowUp',
      'PageDown',
      'PageUp',
      'Home',
      'End',
      ' '
    ];

    if (!scrollKeys.includes(event.key)) return;

    enableMotion();
  };

  const init = () => {
    initKizzuPageWrapper();
    initKizzuMotion(document);

    window.addEventListener('wheel', enableMotion, {
      passive: true,
      once: true
    });

    window.addEventListener('touchmove', enableMotion, {
      passive: true,
      once: true
    });

    window.addEventListener('keydown', handleKeydown);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initKizzuPageWrapper();
    initKizzuMotion(event.target);

    if (hasUserInteracted) {
      requestAnimationFrame(() => {
        triggerVisibleMotions();
      });
    }
  });

  /*
   * =========================================================
   * BOOST MOBILE FILTER
   * =========================================================
   */

  const MOBILE_BREAKPOINT = 1199;
  const FILTER_OPEN_CLASS = 'has-filter-mobile';
  const REFINE_BUTTON_SELECTOR =
    '.boost-sd__filter-tree-toggle-button';

  const html = document.documentElement;

  let wasFilterOpen =
    html.classList.contains(FILTER_OPEN_CLASS);

  const scrollToRefineBy = () => {
    const refineButton =
      document.querySelector(REFINE_BUTTON_SELECTOR);

    if (!refineButton) {
      console.log('[KIZZU FILTER] Refine By button not found');
      return;
    }

    console.log('[KIZZU FILTER] Scroll to Refine By');

    refineButton.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    });
  };

  const restoreFilterScroll = () => {
    /*
     * Boost/CSS cần thời gian:
     * 1. đóng fixed filter
     * 2. show lại KIZZU
     * 3. restore layout
     */
    setTimeout(() => {
      scrollToRefineBy();

      /*
       * Boost có thể còn update DOM sau lần scroll đầu.
       * Scroll lần 2 để giữ đúng vị trí cuối cùng.
       */
      setTimeout(() => {
        scrollToRefineBy();
      }, 300);
    }, 100);
  };

  const filterObserver = new MutationObserver(() => {
    const isFilterOpen =
      html.classList.contains(FILTER_OPEN_CLASS);

    console.log('[KIZZU FILTER]', {
      wasFilterOpen,
      isFilterOpen
    });

    // OPEN -> CLOSED
    if (
      window.innerWidth <= MOBILE_BREAKPOINT &&
      wasFilterOpen &&
      !isFilterOpen
    ) {
      console.log(
        '[KIZZU FILTER] CLOSED -> scroll to Refine By'
      );

      restoreFilterScroll();
    }

    wasFilterOpen = isFilterOpen;
  });

  filterObserver.observe(html, {
    attributes: true,
    attributeFilter: ['class']
  });
})();
